import ScrollDepthService from '~/services/scroll/ScrollDepthService'

export default ({ $dep }: any) => {
  const scrollDepthService = $dep(ScrollDepthService)
  scrollDepthService.initialize()
}
